module.exports = __webpack_public_path__ + "img/3d-feet.735e0a23.svg";